import { theme as themeConfig } from "UI/theme"
import styled from "styled-components"

export const H1 = styled.h1`
  /* Style for "DZIEŁA" */
  text-shadow: 0 0 12px rgba(223, 74, 50, 0.45);
  color: ${themeConfig.palette.accent.red};
  font-family: "Oswald", sans-serif;
  font-size: 90px;
  font-weight: 600;
  font-style: normal;
  letter-spacing: 0.09em;
  line-height: 1;
  text-align: left;
  text-transform: uppercase;
  margin-bottom: 0.334em;
  margin-top: 0.334em;
  display: inline-block;
  position: relative;
  &:before {
    content: ${({ content }) => content};
    width: ${({ width }) => width ? width : "150%"};
    height: 100%;
    opacity: 0.1;
    position: absolute;
    top: ${({ top }) => top ? top : "-32%"};
    left: ${({ left }) => left ? left : "-25%"};
  }
  
  @media (max-width: 768px) {
    font-size: 35px;
    text-shadow: none;
  }
`

export const H3 = styled.h3`
  text-shadow: 0 0 7px rgba(223, 74, 50, 0.49);
  color: ${themeConfig.palette.text.primary};
  font-family: Oswald;
  font-size: 32px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.08em;
  line-height: 1.125em;
  text-align: left;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 20px;
    text-shadow: none;
  }
`
export const H4 = styled.h4`
  color: ${themeConfig.palette.text.secondary};
  font-family: Oswald;
  font-size: 20px;
  letter-spacing: 2px;
  line-height: 30px;

    @media (max-width: 768px) {
    font-size: 14px;
    letter-spacing: 1.68px;
  }
`
